import { render, staticRenderFns } from "./NumberReferences.vue?vue&type=template&id=86f421a0&scoped=true"
import script from "./NumberReferences.vue?vue&type=script&lang=js"
export * from "./NumberReferences.vue?vue&type=script&lang=js"
import style0 from "./NumberReferences.vue?vue&type=style&index=0&id=86f421a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f421a0",
  null
  
)

export default component.exports